module.exports = __webpack_public_path__ + "img/account_personalcard.6cc1cb02.svg";